<template>
  <div class="col-md-4 container recent-blogs">
    <h6 class="recent-blog__title mb-4">RECENT BLOGS</h6>
    <div v-for="(blog, index) in getBlogs" :key="'blog' + index">
      <div
        v-if="blog"
        class="recent-blog__card"
        @click="
          () =>
            $router.push({
              path: `/blogs/${blog.id}/${blog.attributes.seo_url}`,
            })
        "
      >
        <div v-if="blog.attributes.image.data" class="">
          <img
            :src="`https://cms.aliff.in${blog.attributes.image.data.attributes.formats.small.url}`"
            class="img-fluid blog-img-1"
          />
        </div>
        <!-- <p class="recent-blog__sub-title">Foreign education consultants</p> -->
        <p class="recent-blog__sub-title">{{ blog.attributes.heading }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getBlogs"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/RecentBlogs.vue